import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { categories } from '../../data/categories';
import { mainNav, shopShortcuts } from '../../data/navigation';
import { store } from '../../data/store';
import { useOverlay } from '../../hooks/useOverlay';
import { easeOut } from '../../utils/motion';
interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}
export function MobileMenu({
  open,
  onClose
}: MobileMenuProps) {
  useOverlay(open, onClose);
  return <AnimatePresence data-id="element-444" data-mp="1o1dq2w12akp2">
      {open && <>
          <motion.div className="fixed inset-0 z-50 bg-ink/40 lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} aria-hidden data-id="element-445" data-mp="1o25mua6eaogx" />
          <motion.div role="dialog" aria-modal="true" aria-label="Menu" className="fixed inset-y-0 left-0 z-50 flex w-[88%] max-w-sm flex-col overflow-y-auto bg-paper lg:hidden" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.28,
        ease: easeOut
      }} data-id="element-446" data-mp="qlgoiqgnm4ca">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-447" data-mp="dx8j019sc8vs">
              <span className="font-display text-xl" data-id="element-448" data-mp="3de6qyxdlny6d">Menu</span>
              <button type="button" onClick={onClose} aria-label="Fermer le menu" className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-shell" data-id="element-449" data-mp="3ibgeg7hfhzrk">
                <XIcon className="h-5 w-5" data-id="element-450" data-mp="3rdy30skk34hq" />
              </button>
            </div>
            <nav aria-label="Navigation mobile" className="px-5 py-6" data-id="element-451" data-mp="11mjd4zwmr50y">
              <ul className="space-y-1" data-id="element-452" data-mp="16lw704lx5cd1">
                {mainNav.map(item => <li key={item.to} data-id="element-453" data-mp="32pah0mrquxiq">
                    <Link to={item.to} className="block py-2 font-display text-4xl" data-id="element-454" data-mp="32o938ajcfwxb">
                      {item.label}
                    </Link>
                  </li>)}
                <li data-id="element-455" data-mp="3cmovigu3xc8e">
                  <Link to="/favoris" className="block py-2 font-display text-4xl" data-id="element-456" data-mp="3cn8436xvao9r">
                    Favoris
                  </Link>
                </li>
              </ul>
              <div className="mt-8 border-t border-line pt-6" data-id="element-457" data-mp="2k045bjpdb66f">
                <p className="mb-3 text-xs font-medium text-muted" data-id="element-458" data-mp="2ezzottogmbg7">Univers</p>
                <ul className="space-y-3" data-id="element-459" data-mp="2exwoafpokzx8">
                  {categories.map(c => <li key={c.id} data-id="element-460" data-mp="2tq6x5gkr6e36">
                      <Link to={`/boutique?categorie=${c.id}`} className="flex items-center gap-3" data-id="element-461" data-mp="2oyffxwnhlkpp">
                        <img src={c.image} alt="" className="h-12 w-12 rounded-sm object-cover" data-id="element-462" data-mp="218bdhsm1br0a" />
                        <span className="text-sm font-medium" data-id="element-463" data-mp="1w9rn9g0ert24">{c.name}</span>
                      </Link>
                    </li>)}
                </ul>
              </div>
              <ul className="mt-8 flex flex-wrap gap-2 border-t border-line pt-6" data-id="element-464" data-mp="gi5vz3ui9203">
                {shopShortcuts.slice(1).map(s => <li key={s.label} data-id="element-465" data-mp="2rspz716bxde">
                    <Link to={s.to} className="inline-flex h-9 items-center rounded-full border border-line px-4 text-sm" data-id="element-466" data-mp="2oodlmdk1vbn">
                      {s.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>
            <div className="mt-auto border-t border-line bg-shell px-5 py-5 text-sm" data-id="element-467" data-mp="zha141ixebmh">
              <p className="font-medium" data-id="element-468" data-mp="lhsb5itw8sbj">{store.address}, {store.city}</p>
              <p className="mt-1 text-muted" data-id="element-469" data-mp="qgby9mk84a5h">
                {store.hours[0].days} · {store.hours[0].time}
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}